import React, { useEffect, useContext } from "react";
import { useState } from "react";
import {
  Container,
  Row,
  Col,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import { BsTable } from "react-icons/bs";
import { getFundByAmc } from "../../stores/services/funds.service";
import { getAccountByFund } from "../../stores/services/account.service";
import {
  getBankStatement,
  getBankStatementOpeningBalance,
} from "../../stores/services/report.service";
import { PDFExport, savePDF } from "@progress/kendo-react-pdf";
import ReportHeader from "./report-header";
import {
  getChartOfAccounts,
  getNewChartsOfAccountsByFund,
} from "../../stores/services/chatofaccounts.service";
import {
  exportToTxt,
  generateExcel,
  getAllLedgers,
} from "../../utils/customFunction";
import Autocomplete from "@mui/material/Autocomplete";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";
import { useSelector } from "react-redux";
import { ThemeContext } from "../../contexts/ThemeContext";

//api for general ledger reports
import {
  getGeneralLedgerReport,
  getDailyBalance,
} from "../../stores/services/general-ledger-report.service";
import "./table.css";
import "./autocomplete.css";
import Select from "react-select";
import ReportTemplates from "../../components/ReportTemplate/ReportTemplate";
import html2pdf from "html2pdf.js";

const GeneralLegderReport = () => {
  const contentRef = React.useRef(null);
  const ColumnHeading = [
    { label: "Vr. No.", value: "Vr. No." },
    { label: "Reference No.", value: "Reference No." },
    { label: "Instrument No.", value: "Instrument No." },
    { label: "Settlement Date", value: "Settlement Date" },
    { label: "Description", value: "Description" },
    { label: "Debit", value: "Debit" },
    { label: "Credit", value: "Credit" },
    { label: "Balance", value: "Balance" },
  ];
  const [ColumnArr, setColumnArr] = useState(ColumnHeading);
  const [selectedValues, setSelectedValues] = useState<any>({
    heading: "",
    sub_heading: "",
    columns: ColumnHeading?.map?.((col) => col?.value),
    balance: ["Opening Balance", "Closing Balance"],
  });
  const [fontSizeVal, setFontSizeVal] = useState<any>(18);
  const [paperSizeVal, setPaperSizeVal] = useState("A4");
  const [layoutVal, setLayoutVal] = useState("Landscape");
  const [marginPDF, setMarginPDF] = useState("1cm");
  const [scalePDF, setScalePDF] = useState(0.5);
  const [screenSizePerPdf, setScreenSizePerPdf] = useState();
  const [dimensionOfPages, setDimensionOfPages] = useState<any>();
  const [isSearchTrue, setIsSearchTrue] = useState(false);
  const [loadingExcel, setLoadingExcel] = useState(false);
  const [loadingPDF, setLoadingPDF] = useState(false);
  const [loadingText, setLoadingText] = useState(false);
  const contentStyle = {
    // width: `${8.5 * 152.47}px`,
    width: `${Number(
      dimensionOfPages?.find((item) => item?.key === paperSizeVal)
        ?.dimensions[layoutVal === "Portrait" ? 0 : 1]
    ) * Number(screenSizePerPdf)
      }px`,
    height: "auto",
    margin: "0 auto",
  };
  const [itemsPerPage, setItemsPerPage] = useState<any>(10);
  const [itemsToShow, setItemsToShow] = useState(10);
  const [screen, setScreen] = useState<any>();
  const theme = useSelector((state: any) => state.ThemeModeReducer.Theme);
  const pdfExportComponent = React.useRef<PDFExport>(null);
  const context = useContext(ThemeContext);
  const [fund_code, setFund_code] = useState(
    JSON.parse(sessionStorage.getItem("fund_code") || "[]")
  );
  const [loading, setLoading] = useState(false);
  const email = sessionStorage.getItem("email") || "";
  const amc_code = sessionStorage.getItem("amc_code") || "";
  const amc_name = sessionStorage.getItem("amc_name") || "";
  // const chartOfAccounts = useSelector((state: any) => state.chartofAccounts);
  const [chartOfAccounts, setChartOfAccounts] = useState<any>(undefined);

  let date = new Date();
  const [bankStatement, setBankStatement] = useState<any>([]);
  const [bankStatementDataCount, SetBankStatementDataCount] = useState(0);
  const [allFunds, setAllFunds] = useState<any>([]);
  const [allFundAccounts, setAllFundsAccounts] = useState<any>([]);
  const [fund, setFund] = useState("");
  const [type, setType] = useState("");
  const [fundAccount, setFundAccount] = useState("");
  const [accountTitle, setAccountTitle] = useState("");
  const [openingBalance, setOpeningBalance] = useState("");
  const [closingBalance, setClosingBalance] = useState("");
  const [fromDate, setFromDate] = useState(moment(date).format("YYYY-MM-DD"));
  const [toDate, setToDate] = useState(moment(date).format("YYYY-MM-DD"));

  const [resAmc, setResAmc] = useState("");
  const [resFund, setResFund] = useState("");
  const [resType, setResType] = useState("");
  const [resFundAccount, setResFundAccount] = useState("");
  const [resAccountTitle, setResAccountTitle] = useState("");
  const [resFromDate, setResFromDate] = useState(
    moment(date).format("YYYY-MM-DD")
  );
  const [resToDate, setResToDate] = useState(moment(date).format("YYYY-MM-DD"));

  const [legders, setLegders] = useState<any>([]);

  //ledger autocomplete
  const [valueSelectedLedger, setValueSelectedLedger] = React.useState<
    string | null
  >("");
  const [inputValueSelectedLedger, setInputValueSelectedLedger] =
    React.useState("");

  const [ledgerOption, setLedgerOption] = useState<any>([]);

  // ledger response data
  const [ledgerResponse, setLedgerResponse] = useState<any>([]);
  const [ledgerTransactions, setLedgerTransactions] = useState<any>([]);

  const [ledgerResponseMainFamilyName, setLedgerResponseMainFamilyName] =
    useState<any>("");
  const [ledgerResponseFamilyName, setLedgerResponseFamilyName] =
    useState<any>("");
  const [ledgerResponseSubFamilyName, setLedgerResponseSubFamilyName] =
    useState<any>("");

  //opening balance state for reports
  const [reportOpeningBalance, setReportOpeningBalance] = useState<any>([]);

  // const [reportBalance, setReportBalance] = useState<any>("0");
  let reportBalance = 0.0;
  const [reportClosingBalance, setReportClosingBalance] = useState<any>("0");
  const [fetched, setFetched] = useState(false);
  const [ledgerResponseCode, setLedgerResponseCode] = useState<any>("");
  const [ledgerResponseName, setLedgerResponseName] = useState<any>("");

  const getAllAmcFunds = async () => {
    try {
      allFundAccounts.length = 0;
      setAllFundsAccounts(allFundAccounts);
      allFunds.length = 0;
      setAllFunds(allFunds);
      const response = await getFundByAmc(
        email,
        amc_code,
        fund_code?.length > 0 ? fund_code : ""
      );
      setAllFunds(response.data.data);
    } catch (error) { }
  };

  React.useEffect(() => {
    if (sessionStorage.getItem("fund_code")) {
      setFund_code(JSON.parse(sessionStorage.getItem("fund_code") || "[]"));
    } else {
      setFund_code(undefined);
    }
  }, []);

  React.useEffect(() => {
    const handleStorageChange = () => {
      const fundCode = sessionStorage.getItem("fund_code");
      setFund_code(fundCode ? JSON.parse(fundCode) : undefined);
    };

    handleStorageChange();

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  React.useEffect(() => {
    getAllAmcFunds();
  }, [fund_code]);

  // useEffect(() => {

  //   getAllAmcFunds();
  // }, []);

  const getAllLegders = async () => {
    // const response = await getChartOfAccounts(email);
    // if (response.data.status == 200) {
    // let ledgers = getAllLedgers(response.data.data.main_family);
    let ledgers = getAllLedgers(chartOfAccounts);
    setLegders(ledgers);
    // }
  };
  useEffect(() => {
    if (chartOfAccounts && chartOfAccounts.length > 0) {
      getAllLegders();
    }
  }, [chartOfAccounts]);

  const getChartOfAccountsFromBackend = async () => {
    try {
      setLoading(true);
      let response = await getNewChartsOfAccountsByFund(
        email,
        amc_code,
        fund?.split("-")[fund?.split("-").length - 1].trim()
      );
      if (response.data.status === 200) {
        setChartOfAccounts(response.data.data?.main_family);
        setLoading(false);
      } else {
        toast.error("No associated chart of account!");

        setChartOfAccounts(undefined);
      }
    } catch (err: any) {
      if (err.response !== undefined) {
        toast.error(err.response.data.message?.toString());
      } else {
        toast.error(err.message || "Request Failed!");
      }
    }
  };

  React.useEffect(() => {
    if (fund) {
      getChartOfAccountsFromBackend();
    }
  }, [fund]);

  useEffect(() => {
    legders.map((item, index) => {
      if (index === 0) {
        if (item.name) {
          return setLedgerOption([
            {
              label: `${item.code} - ${item.name}`,
            },
          ]);
        } else if (item.bank) {
          return setLedgerOption([
            {
              label: `${item.code} - ${item.bank}`,
            },
          ]);
        }
      }

      if (item.name) {
        return setLedgerOption((prevState) => [
          ...prevState,
          {
            label: `${item.code} - ${item.name}`,
          },
        ]);
      } else if (item.bank) {
        return setLedgerOption((prevState) => [
          ...prevState,
          {
            label: `${item.code} - ${item.bank}`,
          },
        ]);
      }
    });
  }, [legders]);

  // let txnTypes = JSON.parse(sessionStorage.getItem("txnType") || "");
  let txnTypes = useSelector((state: any) => state.txnTypes);

  const CapTxnType = (type: any) => {
    let i, txType;
    for (i = 0; i < txnTypes.length; i++) {
      if (txnTypes[i].api_name === type) {
        txType = txnTypes[i].dis_name;
        break;
      }
    }
    return txType;
  };

  // const renderFundsDropDown = () => {
  //   return allFunds.map((item: any, index: number) => {
  //     return (
  //       <option key={index} value={item.symbol_code}>
  //         {item.fund_name} - {item.symbol_code}
  //       </option>
  //     );
  //   });
  // };

  const renderFundsDropDown = () => {
    return allFunds.map((item: any, index: number) => {
      return {
        value: item.symbol_code,
        label: `${item.fund_name} - ${item.symbol_code}`,
      };
    });
  };

  const getFundAccounts = async (fund_code) => {
    try {
      allFundAccounts.length = 0;
      setAllFundsAccounts(allFundAccounts);
      const accResponse = await getAccountByFund(email, fund_code, amc_code);
      setAllFundsAccounts(accResponse.data.data);
    } catch (error) { }
  };

  const renderFundAccountsDropDown = () => {
    return allFundAccounts.map((item: any, index: number) => {
      return (
        <option key={index} value={item.account_no}>
          {item.bank_name} ({item.account_title})
        </option>
      );
    });
  };

  const renderLegdersDropDown = () => {
    return legders.map((item: any, index: number) => {
      return (
        <option key={index} value={item.code}>
          {item.code} - {item.name != undefined ? item.name : item.bank}
        </option>
      );
    });
  };

  //code for search data for Reports

  // const searchData = async () => {
  //   try {
  //     bankStatement.length = 0;
  //     setBankStatement(bankStatement);
  //     setOpeningBalance("0");
  //     setClosingBalance("0");
  //     setLoading(true);
  //     // let fromMonths = new Date(fromDate);
  //     // let toMonths = new Date(toDate);
  //     // var premonths;
  //     // premonths = (toMonths.getFullYear() - fromMonths.getFullYear()) * 12;
  //     // premonths -= fromMonths.getMonth();
  //     // premonths += toMonths.getMonth();
  //     // if(premonths<6){
  //     // const response = await getBankStatement(email, fundAccount, fromDate,toDate,type);
  //     const response = await getBankStatement(
  //       email,
  //       fundAccount,
  //       fromDate,
  //       toDate,
  //       "Realized"
  //     );
  //     const openingResponse = await getBankStatementOpeningBalance(
  //       email,
  //       fundAccount,
  //       fromDate
  //     );
  //     let array = Object.entries(response.data.data);
  //     let array1 = Object.entries(openingResponse.data.data);
  //     let data: any = [];
  //     let balance = 0;
  //     if (array1.length > 0) {
  //       let temp = [] as any;
  //       temp = array1[0][1];

  //       if (type == "Transaction" || type == "") {
  //         setOpeningBalance(
  //           temp.Record.processed_opening_balance == "0"
  //             ? "0"
  //             : temp.Record.processed_opening_balance
  //         );
  //         balance = parseFloat(
  //           temp.Record.processed_opening_balance == "0"
  //             ? "0"
  //             : temp.Record.processed_opening_balance
  //         );
  //       } else {
  //         setOpeningBalance("0");
  //         balance = parseFloat("0");
  //         setOpeningBalance(
  //           temp.Record.realized_opening_balance == "0"
  //             ? "0"
  //             : temp.Record.realized_opening_balance
  //         );
  //         balance = parseFloat(
  //           temp.Record.realized_opening_balance == "0"
  //             ? "0"
  //             : temp.Record.realized_opening_balance
  //         );
  //       }
  //     }
  //     setResAmc(amc_name);
  //     setResFund(fund);
  //     setResType(type);
  //     setResFundAccount(fundAccount);
  //     setResAccountTitle(accountTitle);
  //     setResFromDate(fromDate);
  //     setResToDate(toDate);
  //     array.forEach(([key, value]) => {
  //       data = value;
  //       let record = [];
  //       record["Record"] = data.Record;
  //       record["Record"]["ledger_id"] = data.Key;
  //       balance +=
  //         parseFloat(data.Record.debit_amount) -
  //         parseFloat(data.Record.credit_amount);
  //       record["Record"]["balance"] = balance.toFixed(4);
  //       bankStatement.push(record);
  //     });
  //     setClosingBalance(balance.toFixed(4));
  //     SetBankStatementDataCount(bankStatement.length);
  //     setLoading(false);
  //     // }else{
  //     //   toast.error('You cannot generate report upto 6 months')
  //     //   setLoading(false);
  //     // }
  //   } catch (error) {
  //     setLoading(false);
  //   }
  // };

  const getGeneralLedger = async () => {
    setIsSearchTrue(false);
    setFetched(false);
    setLoading(true);
    setItemsPerPage(10);
    setLedgerResponse([]);
    let ledger_code = parseInt(
      inputValueSelectedLedger?.split("-")[0]?.replace(/\s+/g, "")
    );
    let start_date = fromDate;
    let end_date = toDate;
    let fund_code = fund?.split("-")[1]?.trim();

    // const balance = await getDailyBalance(start_date, ledger_code, fund_code);

    // reportBalance = await parseFloat(
    //   balance?.data?.data[0]?.processed_opening_balance
    // );
    // console.log("Balance => ", balance.data.data);
    // if (balance.data.status === 404) {
    //   setReportOpeningBalance(0);
    // } else {
    //   setReportOpeningBalance([balance.data.data]);
    // }

    const response = await getGeneralLedgerReport(
      ledger_code,
      fund_code,
      start_date,
      end_date
    );

    if (response.data.status === 404) {
      toast.error("No record found for selected Ledger/Date");
      setLoading(false);
      return;
    } else {
      // setLedgerResponseAccountCode(response.data.data[0].account_number);
      // setLedgerResponseAccountName(response.data.data[0].account_title);
      // setLedgerResponseAMC(response.data.data[0].amc_code);
      setLedgerResponseCode(response.data.data[0].gl_code);

      setLedgerResponseName(response.data.data[0].gl_name);
      // setLedgerResponseBankCode(response.data.data[0].bank_code);
      // setLedgerResponseBranch(response.data.data[0].branch);
      setLedgerResponseFamilyName(response.data.data[0].family_name);
      setLedgerResponseMainFamilyName(response.data.data[0].main_family_name);
      setLedgerResponseSubFamilyName(response.data.data[0].sub_family_name);

      setLedgerResponse(response.data.data);
      setLedgerTransactions(response.data.transactions);
      setReportOpeningBalance(response.data.opening_balance || 0);

      setFetched(true);
      setIsSearchTrue(true);
      setFontSizeVal(18);
    }
    setLoading(false);
  };

  const numberWithCommas = (amount: any) => {
    return amount.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
  };

  const selectedFundName = React.useMemo(() => {
    const selectedFund =
      allFunds &&
      allFunds?.find(
        (item) => `${item.fund_name} - ${item.symbol_code}` === fund
      );
    return selectedFund
      ? {
        value: selectedFund.symbol_code,
        label: `${selectedFund.fund_name} - ${selectedFund.symbol_code}`,
      }
      : null;
  }, [allFunds, fund]);

  const customStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    option: (styles, { isFocused, isSelected }) => ({
      ...styles,
      background: isFocused
        ? "hsla(291, 64%, 42%, 0.5)"
        : isSelected
          ? "hsla(291, 64%, 42%, 1)"
          : undefined,
      zIndex: 1,
    }),
    menuList: (styles) => ({
      ...styles,
      background: theme == "dark" ? "#3b3b3b" : "#ffffff",
      color: theme == "dark" ? "white" : "",
    }),
    menu: (base) => ({
      ...base,
      zIndex: 100,
    }),
    control: (base, state) => ({
      ...base,
      background: theme == "dark" ? "#25273a" : "#f2f2f2",
      borderRadius: "0.4285rem",
      borderColor: state.isFocused
        ? "#1d8cf8"
        : theme !== "light"
          ? "#2b3553"
          : "",
      boxShadow: state.isFocused ? null : null,
      "&:hover": {
        borderColor: state.isFocused ? "" : "#ba54f5",
      },
      '& .react-select__input input[type="color"]': {
        color: theme === "dark" ? "red" : "black",
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: theme == "dark" ? "white" : "black",
    }),
    input: (base) => ({
      ...base,
      color: theme == "dark" ? "white" : "black",
    }),
  };

  useEffect(() => {
    const elements = document.querySelectorAll(
      "#test"
    ) as NodeListOf<HTMLElement>;
    elements.forEach((element) => {
      element.style.setProperty("font-size", `${fontSizeVal}px`, "important");
    });
  }, [fontSizeVal, itemsToShow, selectedValues, isSearchTrue]);

  useEffect(() => {
    const handleScreenResize = () => {
      setScreen(window?.outerWidth);
    };

    window.addEventListener("resize", handleScreenResize);
    handleScreenResize();

    return () => {
      window.removeEventListener("resize", handleScreenResize);
    };
  }, []);

  const fixedOrder = [
    "Vr. No.",
    "Reference No.",
    "Instrument No.",
    "Settlement Date",
    "Description",
    "Debit",
    "Credit",
    "Balance",
  ];

  const handleDownloadSampleFile = () => {
    const TotalBalance = selectedValues?.columns?.map((ele, index) => {
      if (selectedValues?.columns?.length - 1 === index) {
        return `Opening Balance: ${reportOpeningBalance
          ? Math.sign(parseFloat(reportOpeningBalance)) === 1
            ? `${numberWithCommas(parseFloat(reportOpeningBalance))} Dr.`
            : Math.sign(parseFloat(reportOpeningBalance)) === -1
              ? `${numberWithCommas(parseFloat(reportOpeningBalance))} Cr.`
              : "0"
          : "0"
          }`;
      } else {
        return "";
      }
    });

    const headings = [
      [selectedValues?.heading ? selectedValues?.heading : "", "", "", ""],
      [
        selectedValues?.sub_heading ? selectedValues?.sub_heading : "",
        "",
        "",
        "",
      ],
      [
        "From Date",
        `${moment(fromDate).format("DD-MM-YYYY")}`,
        "To Date",
        `${moment(toDate).format("DD-MM-YYYY")}`,
      ],
      [
        "Ledger Code",
        `${ledgerResponseCode}`,
        "Ledger Name",
        `${ledgerResponseName}`,
      ],
      [
        "Fund Code",
        `${fund.split("-")[1].trim()}`,
        "Fund Name",
        `${fund.split("-")[0].trim()}`,
      ],
      selectedValues?.balance?.includes("Opening Balance") &&
      (selectedValues?.columns?.length > 1
        ? [...TotalBalance]
        : ["Opening Balance: 0"]),
    ];

    const dataSequence = ledgerResponse
      ?.slice(0, itemsToShow)
      ?.map((item, index) => {
        if (index === 0) {
          reportBalance = reportOpeningBalance
            ? reportOpeningBalance
              ? parseFloat(reportOpeningBalance) !== 0
                ? parseFloat(reportOpeningBalance)
                : 0
              : 0
            : 0;
          reportBalance +=
            parseFloat(item.debit_amount.toFixed(4)) -
            parseFloat(item.credit_amount.toFixed(4));
          return {
            Vr_No: item._id.split("_")[1],
            Reference_No: item.txn_id,
            Instrument_No:
              ledgerTransactions.find((txn) => txn.txn_id == item.txn_id)
                ?.instrument_no || "",
            Settlement_Date: moment(item.settlement_date).format("DD-MM-YYYY"),
            Description: `${item.description?.slice(0, 400)}${item.description.length > 400 ? "..." : ""
              }${item.description.length < 395
                ? ledgerTransactions
                  .find((txn) => txn.txn_id === item.txn_id)
                  ?.description?.includes("(Reversed)")
                  ? "(Reversed)"
                  : ""
                : ""
              }`,
            Debit: numberWithCommas(parseFloat(item.debit_amount).toFixed(4)),
            Credit: numberWithCommas(parseFloat(item.credit_amount).toFixed(4)),
            Balance: reportBalance
              ? Math.sign(reportBalance) === 1
                ? `${numberWithCommas(reportBalance.toFixed(4))} Dr.`
                : Math.sign(reportBalance) === -1
                  ? `${numberWithCommas(
                    reportBalance.toFixed(4).toString().split("-")[1]
                  )} Cr.`
                  : "0"
              : "0",
          };
        } else {
          reportBalance +=
            parseFloat(item.debit_amount.toFixed(4)) -
            parseFloat(item.credit_amount.toFixed(4));
          return {
            Vr_No: item._id.split("_")[1],
            Reference_No: item.txn_id,
            Instrument_No:
              ledgerTransactions.find((txn) => txn.txn_id == item.txn_id)
                ?.instrument_no || "",
            Settlement_Date: moment(item.settlement_date).format("DD-MM-YYYY"),
            Description: `${item.description}${ledgerTransactions
              .find((txn) => txn.txn_id === item.txn_id)
              ?.description?.includes(" (Reversed)")
              ? " (Reversed)"
              : ""
              }`,
            Debit: numberWithCommas(parseFloat(item.debit_amount).toFixed(4)),
            Credit: numberWithCommas(parseFloat(item.credit_amount).toFixed(4)),
            Balance: reportBalance
              ? Math.sign(reportBalance) === 1
                ? `${numberWithCommas(reportBalance.toFixed(4))} Dr.`
                : Math.sign(reportBalance) === -1
                  ? `${numberWithCommas(
                    reportBalance.toFixed(4).toString().split("-")[1]
                  )} Cr.`
                  : "0"
              : "0",
          };
        }
      });

    // dataSequence.push({
    //   Vr_No: "",
    //   Reference_No: "",
    //   Instrument_No: "",
    //   Settlement_Date: "",
    //   Description: "",
    //   Debit: "",
    //   Credit: "",
    //   Balance: selectedValues?.balance?.includes("Closing Balance") ? `Closing Units: ${reportBalance
    //     ? Math.sign(reportBalance) === 1
    //       ? `${numberWithCommas(
    //         reportBalance.toFixed(4)
    //       )} Dr.`
    //       : Math.sign(reportBalance) === -1
    //         ? `${numberWithCommas(
    //           reportBalance
    //             .toFixed(4)
    //             .toString()
    //             .split("-")[1]
    //         )} Cr.`
    //         : "0"
    //     : "0"}` : 0,
    // })

    const reorderColumns = (columns, order) => {
      return order.filter((column) => columns.includes(column));
    };

    const reorderedColumns = reorderColumns(
      selectedValues?.columns,
      fixedOrder
    );

    const ArrayData =
      selectedValues?.columns?.length > 0 &&
      dataSequence?.map((entry) => {
        const result = {};
        reorderedColumns.forEach((column) => {
          if (column === "Vr. No.") {
            result[column] = entry?.Vr_No;
          } else if (column === "Reference No.") {
            result[column] = entry?.Reference_No;
          } else if (column === "Instrument No.") {
            result[column] = entry?.Instrument_No;
          } else if (column === "Settlement Date") {
            result[column] = entry?.Settlement_Date;
          } else if (column === "Description") {
            result[column] = entry?.Description;
          } else if (column === "Debit") {
            result[column] = numberWithCommas(entry?.Debit);
          } else if (column === "Credit") {
            result[column] = numberWithCommas(entry?.Credit);
          } else if (column === "Balance") {
            result[column] = numberWithCommas(entry?.Balance);
          }
        });
        return result;
      });

    if (ArrayData.length > 0) {
      const keys = Object.keys(ArrayData[0]);
      const lastKey = keys[keys.length - 1];

      const newObj1 = keys.reduce((acc, key) => {
        acc[key] =
          key === lastKey
            ? selectedValues?.balance?.includes("Closing Balance")
              ? `Closing Units: ${reportBalance
                ? Math.sign(reportBalance) === 1
                  ? `${numberWithCommas(reportBalance.toFixed(4))} Dr.`
                  : Math.sign(reportBalance) === -1
                    ? `${numberWithCommas(
                      reportBalance.toFixed(4).toString().split("-")[1]
                    )} Cr.`
                    : "0"
                : "0"
              }`
              : ""
            : "";
        return acc;
      }, {});
      ArrayData.push(newObj1);
    }

    generateExcel(
      "General Ledger Report",
      "General Ledger Report",
      "File",
      "File",
      "DCCL",
      headings,
      reorderedColumns,
      ArrayData,
      [],
      []
    );
    setLoadingExcel(false);
  };

  const handleTXT = () => {
    const TotalBalance = selectedValues?.columns?.map((ele, index) => {
      if (selectedValues?.columns?.length - 1 === index) {
        return `Opening Balance: ${reportOpeningBalance
          ? Math.sign(parseFloat(reportOpeningBalance)) === 1
            ? `${numberWithCommas(parseFloat(reportOpeningBalance))} Dr.`
            : Math.sign(parseFloat(reportOpeningBalance)) === -1
              ? `${numberWithCommas(parseFloat(reportOpeningBalance))} Cr.`
              : "0"
          : "0"
          }`;
      } else {
        return "";
      }
    });

    const dataSequence = ledgerResponse
      ?.slice(0, itemsToShow)
      ?.map((item, index) => {
        if (index === 0) {
          reportBalance = reportOpeningBalance
            ? reportOpeningBalance
              ? parseFloat(reportOpeningBalance) !== 0
                ? parseFloat(reportOpeningBalance)
                : 0
              : 0
            : 0;
          reportBalance +=
            parseFloat(item.debit_amount.toFixed(4)) -
            parseFloat(item.credit_amount.toFixed(4));
          return {
            Vr_No: item._id.split("_")[1],
            Reference_No: item.txn_id,
            Instrument_No:
              ledgerTransactions.find((txn) => txn.txn_id == item.txn_id)
                ?.instrument_no || "",
            Settlement_Date: moment(item.settlement_date).format("DD-MM-YYYY"),
            Description: `${item.description?.slice(0, 400)}${item.description.length > 400 ? "..." : ""
              }${item.description.length < 395
                ? ledgerTransactions
                  .find((txn) => txn.txn_id === item.txn_id)
                  ?.description?.includes("(Reversed)")
                  ? "(Reversed)"
                  : ""
                : ""
              }`,
            Debit: numberWithCommas(parseFloat(item.debit_amount).toFixed(4)),
            Credit: numberWithCommas(parseFloat(item.credit_amount).toFixed(4)),
            Balance: reportBalance
              ? Math.sign(reportBalance) === 1
                ? `${numberWithCommas(reportBalance.toFixed(4))} Dr.`
                : Math.sign(reportBalance) === -1
                  ? `${numberWithCommas(
                    reportBalance.toFixed(4).toString().split("-")[1]
                  )} Cr.`
                  : "0"
              : "0",
          };
        } else {
          reportBalance +=
            parseFloat(item.debit_amount.toFixed(4)) -
            parseFloat(item.credit_amount.toFixed(4));
          return {
            Vr_No: item._id.split("_")[1],
            Reference_No: item.txn_id,
            Instrument_No:
              ledgerTransactions.find((txn) => txn.txn_id == item.txn_id)
                ?.instrument_no || "",
            Settlement_Date: moment(item.settlement_date).format("DD-MM-YYYY"),
            Description: `${item.description}${ledgerTransactions
              .find((txn) => txn.txn_id === item.txn_id)
              ?.description?.includes(" (Reversed)")
              ? " (Reversed)"
              : ""
              }`,
            Debit: numberWithCommas(parseFloat(item.debit_amount).toFixed(4)),
            Credit: numberWithCommas(parseFloat(item.credit_amount).toFixed(4)),
            Balance: reportBalance
              ? Math.sign(reportBalance) === 1
                ? `${numberWithCommas(reportBalance.toFixed(4))} Dr.`
                : Math.sign(reportBalance) === -1
                  ? `${numberWithCommas(
                    reportBalance.toFixed(4).toString().split("-")[1]
                  )} Cr.`
                  : "0"
              : "0",
          };
        }
      });

    // dataSequence.push({
    //   Vr_No: "",
    //   Reference_No: "",
    //   Instrument_No: "",
    //   Settlement_Date: "",
    //   Description: "",
    //   Debit: "",
    //   Credit: "",
    //   Balance: selectedValues?.balance?.includes("Closing Balance") ? `Closing Units: ${reportBalance
    //     ? Math.sign(reportBalance) === 1
    //       ? `${numberWithCommas(
    //         reportBalance.toFixed(4)
    //       )} Dr.`
    //       : Math.sign(reportBalance) === -1
    //         ? `${numberWithCommas(
    //           reportBalance
    //             .toFixed(4)
    //             .toString()
    //             .split("-")[1]
    //         )} Cr.`
    //         : "0"
    //     : "0"}` : 0,
    // })

    const reorderColumns = (columns, order) => {
      return order.filter((column) => columns.includes(column));
    };

    const reorderedColumns = reorderColumns(
      selectedValues?.columns,
      fixedOrder
    );

    const ArrayData =
      selectedValues?.columns?.length > 0 &&
      dataSequence?.map((entry) => {
        const result = {};
        reorderedColumns.forEach((column) => {
          if (column === "Vr. No.") {
            result[column] = entry?.Vr_No;
          } else if (column === "Reference No.") {
            result[column] = entry?.Reference_No;
          } else if (column === "Instrument No.") {
            result[column] = entry?.Instrument_No;
          } else if (column === "Settlement Date") {
            result[column] = entry?.Settlement_Date;
          } else if (column === "Description") {
            result[column] = entry?.Description;
          } else if (column === "Debit") {
            result[column] = numberWithCommas(entry?.Debit);
          } else if (column === "Credit") {
            result[column] = numberWithCommas(entry?.Credit);
          } else if (column === "Balance") {
            result[column] = numberWithCommas(entry?.Balance);
          }
        });
        return result;
      });

    if (ArrayData.length > 0) {
      const keys = Object.keys(ArrayData[0]);
      const lastKey = keys[keys.length - 1];

      const newObj1 = keys.reduce((acc, key) => {
        acc[key] =
          key === lastKey
            ? selectedValues?.balance?.includes("Closing Balance")
              ? `Closing Units: ${reportBalance
                ? Math.sign(reportBalance) === 1
                  ? `${numberWithCommas(reportBalance.toFixed(4))} Dr.`
                  : Math.sign(reportBalance) === -1
                    ? `${numberWithCommas(
                      reportBalance.toFixed(4).toString().split("-")[1]
                    )} Cr.`
                    : "0"
                : "0"
              }`
              : ""
            : "";
        return acc;
      }, {});
      ArrayData.push(newObj1);
    }

    let formattedContent = `${selectedValues?.heading ? selectedValues?.heading : ""
      },,,\n`;
    formattedContent += `${selectedValues?.sub_heading ? selectedValues?.sub_heading : ""
      },,,\n`;
    formattedContent += `"From Date:","${moment(fromDate).format(
      "DD-MM-YYYY"
    )}",`;
    formattedContent += `"To Date:","${moment(toDate).format(
      "DD-MM-YYYY"
    )}",,\n`;
    formattedContent += `"Ledger Code:","${ledgerResponseCode}",`;
    formattedContent += `"Ledger Name:","${ledgerResponseName}",,\n`;
    formattedContent += `"Fund Code:","${fund.split("-")[1].trim()}",`;
    formattedContent += `"Fund Name:","${fund.split("-")[0].trim()}",,\n`;

    formattedContent += TotalBalance?.map((col) => `"${col}"`).join(",") + "\n";

    exportToTxt(
      formattedContent,
      selectedValues,
      ArrayData,
      "General Ledger Report"
    );
    setLoadingText(false);
  };

  const handleShowMore = () => {
    setItemsToShow((prev) => prev + itemsPerPage);
  };

  const handleGeneratePdf = () => {
    const element = contentRef.current;
    let fileName = "General-Legder.pdf";
    const options = {
      filename: fileName,
      margin: [10, 3, 10, 3],
      image: { type: "jpeg", quality: 0.95 },
      html2canvas: { scale: 1 },
      jsPDF: {
        unit: "mm",
        format: paperSizeVal || "A4",
        orientation: layoutVal === "Landscape" ? "landscape" : "portrait",
      },
      pagebreak: { mode: ["avoid-all", "css", "legacy"] },
    };
    html2pdf().from(element).set(options).save();
    setLoadingPDF(false);
  };

  return (
    <>
      <div className="content">
        <Row>
          <Col md="12">
            <Container fluid>
              <ToastContainer limit={1} />
              <div className="">
                <div className="card">
                  <div className="card-header">
                    <h4 className="card-title">General Ledger</h4>
                  </div>
                  <div className="card-body">
                    <Row>
                      <Col md="3">
                        <div className="form-group">
                          <label>Select Fund</label>
                          <Select
                            value={selectedFundName}
                            label={"Select Fund"}
                            onChange={(e) => {
                              setLoading(true);
                              setLedgerResponse([]);
                              setFund(e?.label);
                              getFundAccounts(e?.value);
                              setLoading(false);
                              setItemsPerPage(10);
                              setItemsToShow(10);
                              setValueSelectedLedger("");
                            }}
                            menuPortalTarget={document.body}
                            menuShouldBlockScroll={true}
                            isClearable={true}
                            isSearchable={true}
                            name="color"
                            options={renderFundsDropDown()}
                            styles={customStyles}
                          />
                          {/* <select
                            className="form-control"
                            onChange={(e) => {
                              setLoading(true);
                              setLedgerResponse([]);
                              setFund(
                                e.nativeEvent.target == null
                                  ? ""
                                  : e.nativeEvent.target[e.target.selectedIndex]
                                      .text
                              );
                              getFundAccounts(e.target.value);
                              setLoading(false);
                            }}
                          >
                            <option value="" defaultChecked hidden>
                              Select Fund
                            </option>
                            {renderFundsDropDown()}
                          </select> */}
                        </div>
                      </Col>

                      <Col md="3">
                        <div className="form-group">
                          <label>Select Ledger</label>
                          {ledgerOption.length > 1 ? (
                            <Autocomplete
                              className="autocomplete d-inline-block"
                              // id="combo-box-demo"
                              // id="form-control"
                              options={ledgerOption}
                              noOptionsText={
                                <div
                                  style={{
                                    color:
                                      theme === "light"
                                        ? "black"
                                        : "rgba(255, 255, 255, 0.5)",
                                  }}
                                >
                                  No options
                                </div>
                              }
                              style={{ width: "100%", borderRadius: "7px" }}
                              PaperComponent={({ children }) => (
                                <Paper
                                  style={{
                                    background:
                                      theme == "light" ? "" : "#1E1E2F",
                                    color: "white",
                                    position: "absolute",
                                    width: "101%",
                                    left: "-3px",
                                  }}
                                >
                                  {children}
                                </Paper>
                              )}
                              value={valueSelectedLedger}
                              onChange={(
                                event: any,
                                newValue: string | null
                              ) => {
                                setLoading(true);
                                setLedgerResponse([]);
                                setValueSelectedLedger(newValue);
                                setLoading(false);
                                setItemsPerPage(10);
                                setItemsToShow(10);
                              }}
                              inputValue={inputValueSelectedLedger}
                              onInputChange={(event, newInputValue) => {
                                setLoading(true);
                                setLedgerResponse([]);
                                setInputValueSelectedLedger(newInputValue);
                                setLoading(false);
                                setItemsPerPage(10);
                                setItemsToShow(10);
                              }}
                              renderInput={(params) => (
                                <TextField
                                  sx={{
                                    "& .MuiAutocomplete-inputFocused": {
                                      padding: "7px 12px !important",
                                      color:
                                        theme == "light"
                                          ? "black !important"
                                          : "white !important",
                                    },
                                  }}
                                  {...params}
                                  placeholder="Select..."
                                  variant="standard"
                                />
                              )}
                              sx={{
                                "& .MuiAutocomplete-input": {
                                  color:
                                    theme == "light"
                                      ? "black !important"
                                      : "rgba(255, 255, 255, 0.5) !important",
                                },
                                "& .MuiInputLabel-root": {
                                  color:
                                    theme == "light"
                                      ? "black !important"
                                      : "rgba(255, 255, 255, 0.5) !important",
                                },

                                "& .MuiIconButton-root": {
                                  color:
                                    theme == "light"
                                      ? "black !important"
                                      : "rgba(255, 255, 255, 0.5) !important",
                                },
                              }}
                            />
                          ) : !fund ? (
                            <div className="d-flex justify-content-center align-items-center text-center">
                              {/* <label>Select Fund to get ledgers</label> */}
                              <input
                                style={{
                                  colorScheme:
                                    theme == "light" ? "light" : "dark",
                                }}
                                disabled
                                type="text"
                                placeholder="Select Fund to get ledgers"
                                className="form-control py-1"
                              />
                            </div>
                          ) : (
                            <i className="fa fa-spinner fa-spin fa-1x"></i>
                          )}
                        </div>
                      </Col>

                      <Col md="3">
                        <div className="form-group  ">
                          <label>Settlement Date From</label>
                          <input
                            style={{
                              colorScheme: theme == "light" ? "light" : "dark",
                            }}
                            type="date"
                            defaultValue={fromDate}
                            className="form-control py-1"
                            onChange={(e) => {
                              setLoading(true);
                              setLedgerResponse([]);
                              let date = moment(e.target.value).format(
                                "YYYY-MM-DD"
                              );
                              setFromDate(date);
                              setLoading(false);
                              setItemsPerPage(10);
                              setItemsToShow(10);
                            }}
                          />
                        </div>
                      </Col>
                      <Col md="3">
                        <div className="form-group  ">
                          <label>Settlement Date To</label>
                          <input
                            style={{
                              colorScheme: theme == "light" ? "light" : "dark",
                            }}
                            type="date"
                            defaultValue={toDate}
                            className="form-control py-1"
                            onChange={(e) => {
                              setLoading(true);
                              setLedgerResponse([]);
                              let date = moment(e.target.value).format(
                                "YYYY-MM-DD"
                              );
                              setToDate(date);
                              setLoading(false);
                              setItemsPerPage(10);
                              setItemsToShow(10);
                            }}
                          />
                        </div>
                      </Col>

                      <Col md="2">
                        <div className=" ">
                          {/* here Search Button */}
                          <button
                            className="btn btn-primary mt-4"
                            onClick={() => {
                              getGeneralLedger();
                            }}
                            disabled={
                              Boolean(loading) || !inputValueSelectedLedger
                            }
                          >
                            {loading ? (
                              <>
                                <span
                                  className="spinner-border login-txt spinner-border-sm"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                                <span className="login-txt"> Loading...</span>
                              </>
                            ) : (
                              <span>Search</span>
                            )}
                          </button>
                        </div>
                      </Col>
                    </Row>
                    {/* End */}
                  </div>
                </div>

                {/* here Search results for report Data */}
                <div className="card mt-3">
                  <div className="card-body">
                    {/* ------------------ Report template starts here ---------- */}
                    {ledgerResponse.length > 0 && (
                      <Row>
                        <ReportTemplates
                          ColumnArr={ColumnArr}
                          selectedValues={selectedValues}
                          setSelectedValues={setSelectedValues}
                          pdfExportComponent={pdfExportComponent}
                          setFontSizeVal={setFontSizeVal}
                          fontSizeVal={fontSizeVal}
                          setPaperSizeVal={setPaperSizeVal}
                          paperSizeVal={paperSizeVal}
                          setLayoutVal={setLayoutVal}
                          layoutVal={layoutVal}
                          setScalePDF={setScalePDF}
                          scalePDF={scalePDF}
                          setMarginPDF={setMarginPDF}
                          marginPDF={marginPDF}
                          setScreenSizePerPdf={setScreenSizePerPdf}
                          screenSizePerPdf={screenSizePerPdf}
                          setDimensionOfPages={setDimensionOfPages}
                          contentRef={contentRef}
                          fileName={"General-Legder-" + date + ".pdf"}
                          printExcel={handleDownloadSampleFile}
                          printTXT={handleTXT}
                          printpdf={handleGeneratePdf}
                        />
                      </Row>
                    )}
                    {/* ------------------ Report template ends here ---------- */}
                    <div
                      id="printDiv"
                      className="p-4"
                      style={{
                        // background: "white",
                        color: "black",
                        minWidth: "200px",
                        overflowX: "auto",
                        width: "auto",
                      }}
                    >
                      <div
                        style={{
                          width: `${dimensionOfPages?.find(
                            (item) => item?.key === paperSizeVal
                          )?.dimensions[layoutVal === "Portrait" ? 0 : 1]
                            }`,
                          margin: "0 auto",
                          backgroundColor: "white",
                        }}
                        className="border"
                      >
                        <PDFExport
                          paperSize={paperSizeVal || "A4"}
                          margin="1.5cm"
                          // margin={{ top: marginPDF, left: marginPDF, right: marginPDF, bottom: "1.13cm" }}
                          scale={scalePDF}
                          landscape={layoutVal === "Landscape" ? true : false}
                          repeatHeaders={true}
                          fileName={"General-Legder-" + date + ".pdf"}
                          ref={pdfExportComponent}
                        >
                          <div
                            style={{
                              margin: "0.25in"
                            }}
                            ref={contentRef}>
                            {ledgerResponse.length > 0 ? (
                              <>
                                <ReportHeader title="General Ledger" />

                                <Row>
                                  <Col md="3" style={{ marginLeft: "40px" }}>
                                    <Row className="d-flex justify-content-between">
                                      <Col md="5">
                                        <span
                                          id="test"
                                          className="ReportTopStyling"
                                          style={{ fontWeight: "bold" }}
                                        >
                                          From Date:
                                        </span>
                                      </Col>
                                      <Col md="5">
                                        <span
                                          id="test"
                                          className="ReportTopStyling"
                                        >
                                          {moment(fromDate).format(
                                            "DD-MM-YYYY"
                                          )}
                                        </span>
                                      </Col>
                                    </Row>

                                    <Row className="d-flex justify-content-between">
                                      <Col md="5">
                                        <span
                                          id="test"
                                          className="ReportTopStyling"
                                          style={{ fontWeight: "bold" }}
                                        >
                                          Ledger Code:
                                        </span>
                                      </Col>
                                      <Col md="5">
                                        <span
                                          id="test"
                                          className="ReportTopStyling"
                                        >
                                          {ledgerResponseCode}
                                        </span>
                                      </Col>
                                    </Row>
                                  </Col>
                                  <Col md="3" style={{ marginLeft: "40px" }}>
                                    <Row className="d-flex justify-content-between">
                                      <Col md="5">
                                        <span
                                          id="test"
                                          className="ReportTopStyling"
                                          style={{ fontWeight: "bold" }}
                                        >
                                          To Date:
                                        </span>
                                      </Col>
                                      <Col md="5">
                                        <span
                                          id="test"
                                          className="ReportTopStyling"
                                        >
                                          {moment(toDate).format("DD-MM-YYYY")}
                                        </span>
                                      </Col>
                                    </Row>

                                    <Row className="d-flex justify-content-between">
                                      <Col md="5">
                                        <span
                                          id="test"
                                          className="ReportTopStyling"
                                          style={{ fontWeight: "bold" }}
                                        >
                                          Ledger Name:
                                        </span>
                                      </Col>
                                      <Col md="5">
                                        <span
                                          id="test"
                                          className="ReportTopStyling"
                                        >
                                          {ledgerResponseName}
                                        </span>
                                      </Col>
                                    </Row>
                                  </Col>
                                </Row>

                                <Row>
                                  <Col md="3" style={{ marginLeft: "40px" }}>
                                    <Row className="d-flex justify-content-between">
                                      <Col md="5">
                                        <span
                                          id="test"
                                          className="ReportTopStyling"
                                          style={{ fontWeight: "bold" }}
                                        >
                                          Fund Code:
                                        </span>
                                      </Col>
                                      <Col md="5">
                                        <span
                                          id="test"
                                          className="ReportTopStyling"
                                        >
                                          {fund.split("-")[1].trim()}
                                        </span>
                                      </Col>
                                    </Row>
                                  </Col>

                                  <Col md="3" style={{ marginLeft: "40px" }}>
                                    <Row className="d-flex justify-content-between">
                                      <Col md="5">
                                        <span
                                          id="test"
                                          className="ReportTopStyling"
                                          style={{ fontWeight: "bold" }}
                                        >
                                          Fund Name:
                                        </span>
                                      </Col>
                                      <Col md="5">
                                        <span
                                          id="test"
                                          className="ReportTopStyling"
                                        >
                                          {fund.split("-")[0].trim()}
                                        </span>
                                      </Col>
                                    </Row>
                                  </Col>
                                </Row>

                                {selectedValues?.columns?.length > 0 ? (
                                  <div>
                                    <div
                                      style={{
                                        overflowX: "auto",
                                        overflowY: "hidden",
                                      }}
                                    >
                                      {selectedValues?.balance?.includes(
                                        "Opening Balance"
                                      ) && (
                                          <div id="test" className="float-right">
                                            <b id="test">Opening Balance</b>:{" "}
                                            <span> </span>
                                            {/* {reportOpeningBalance
                                  ? numberWithCommas(
                                      parseFloat(
                                        reportOpeningBalance[0]
                                          .processed_opening_balance
                                      )
                                    )
                                  : "0"} */}
                                            {reportOpeningBalance
                                              ? Math.sign(
                                                parseFloat(
                                                  // reportOpeningBalance[0]
                                                  //   .processed_opening_balance
                                                  reportOpeningBalance
                                                )
                                              ) === 1
                                                ? `${numberWithCommas(
                                                  parseFloat(
                                                    // reportOpeningBalance[0]
                                                    //   .processed_opening_balance
                                                    reportOpeningBalance?.toString()?.replace("-", "") || 0
                                                  )
                                                )} Dr.`
                                                : Math.sign(
                                                  parseFloat(
                                                    // reportOpeningBalance[0]
                                                    //   .processed_opening_balance
                                                    reportOpeningBalance
                                                  )
                                                ) === -1
                                                  ? `${numberWithCommas(
                                                    parseFloat(
                                                      // reportOpeningBalance[0]
                                                      //   ?.processed_opening_balance
                                                      reportOpeningBalance?.toString()?.replace("-", "") || 0
                                                    )
                                                  )} Cr.`
                                                  : // ? `${numberWithCommas(
                                                  //     parseFloat(
                                                  //       reportOpeningBalance[0]?.processed_opening_balance?.split(
                                                  //         "-"
                                                  //       )[1]
                                                  //     )
                                                  //   )} Cr.`
                                                  "0"
                                              : "0"}
                                          </div>
                                        )}
                                      <table
                                        className="report border-bottom"
                                        id="table-borderless"
                                        style={{
                                          color: "black",
                                        }}
                                      >
                                        <thead>
                                          <tr style={{ border: "0" }}>
                                            {selectedValues?.columns?.includes(
                                              "Vr. No."
                                            ) && (
                                                <th
                                                  className="htmltoPdfStyle"
                                                  id="test"
                                                >
                                                  Vr. No.
                                                </th>
                                              )}
                                            {selectedValues?.columns?.includes(
                                              "Reference No."
                                            ) && (
                                                <th
                                                  className="htmltoPdfStyle"
                                                  id="test"
                                                >
                                                  Reference No.{" "}
                                                </th>
                                              )}
                                            {selectedValues?.columns?.includes(
                                              "Instrument No."
                                            ) && (
                                                <th
                                                  className="htmltoPdfStyle"
                                                  id="test"
                                                >
                                                  Instrument No.{" "}
                                                </th>
                                              )}
                                            {/* <th>Create Date</th> */}
                                            {selectedValues?.columns?.includes(
                                              "Settlement Date"
                                            ) && (
                                                <th
                                                  className="htmltoPdfStyle"
                                                  id="test"
                                                >
                                                  Settlement Date
                                                </th>
                                              )}

                                            {selectedValues?.columns?.includes(
                                              "Description"
                                            ) && (
                                                <th
                                                  className="htmltoPdfStyle"
                                                  id="test"
                                                  style={{ width: "30%" }}
                                                >
                                                  Description
                                                </th>
                                              )}

                                            {selectedValues?.columns?.includes(
                                              "Debit"
                                            ) && (
                                                <th
                                                  align="right"
                                                  className="htmltoPdfStyle"
                                                  id="test"
                                                >
                                                  Debit
                                                </th>
                                              )}
                                            {selectedValues?.columns?.includes(
                                              "Credit"
                                            ) && (
                                                <th
                                                  className="text-right"
                                                  id="test"
                                                >
                                                  Credit
                                                </th>
                                              )}

                                            {selectedValues?.columns?.includes(
                                              "Balance"
                                            ) && (
                                                <th
                                                  className="text-right"
                                                  id="test"
                                                >
                                                  Balance{" "}
                                                </th>
                                              )}
                                          </tr>
                                        </thead>
                                        <tbody className="report-table-body">
                                          {ledgerResponse.length > 0
                                            ? ledgerResponse
                                              ?.slice(0, itemsToShow)
                                              .map(
                                                (
                                                  item: any,
                                                  index: number
                                                ) => {
                                                  if (index === 0) {
                                                    reportBalance =
                                                      reportOpeningBalance
                                                        ? reportOpeningBalance
                                                          ? //  reportOpeningBalance[0]
                                                          //     .processed_opening_balance
                                                          parseFloat(
                                                            // reportOpeningBalance[0]
                                                            //   .processed_opening_balance
                                                            reportOpeningBalance
                                                          ) !== 0
                                                            ? parseFloat(
                                                              reportOpeningBalance
                                                              // reportOpeningBalance[0]
                                                              //   .processed_opening_balance
                                                            )
                                                            : 0
                                                          : 0
                                                        : 0;
                                                    reportBalance +=
                                                      parseFloat(
                                                        item.debit_amount.toFixed(
                                                          4
                                                        )
                                                      ) -
                                                      parseFloat(
                                                        item.credit_amount.toFixed(
                                                          4
                                                        )
                                                      );
                                                    return (
                                                      <tr key={index}>
                                                        {selectedValues?.columns?.includes(
                                                          "Vr. No."
                                                        ) && (
                                                            <td
                                                              className="htmltoPdfStyle"
                                                              id="test"
                                                            >
                                                              {
                                                                item._id.split(
                                                                  "_"
                                                                )[1]
                                                              }
                                                            </td>
                                                          )}
                                                        {selectedValues?.columns?.includes(
                                                          "Reference No."
                                                        ) && (
                                                            <td
                                                              className="htmltoPdfStyle"
                                                              id="test"
                                                            >
                                                              {item.txn_id}
                                                            </td>
                                                          )}
                                                        {selectedValues?.columns?.includes(
                                                          "Instrument No."
                                                        ) && (
                                                            <td
                                                              className="htmltoPdfStyle"
                                                              id="test"
                                                            >
                                                              {ledgerTransactions.find(
                                                                (txn) =>
                                                                  txn.txn_id ==
                                                                  item.txn_id
                                                              )
                                                                ?.instrument_no ||
                                                                ""}{" "}
                                                            </td>
                                                          )}
                                                        {selectedValues?.columns?.includes(
                                                          "Settlement Date"
                                                        ) && (
                                                            <td
                                                              className="htmltoPdfStyle"
                                                              id="test"
                                                            >
                                                              {moment(
                                                                item.settlement_date
                                                              ).format(
                                                                "DD-MM-YYYY"
                                                              )}
                                                            </td>
                                                          )}

                                                        {selectedValues?.columns?.includes(
                                                          "Description"
                                                        ) && (
                                                            <td
                                                              className="htmltoPdfStyle"
                                                              id="test"
                                                            >
                                                              {item.description?.slice(
                                                                0,
                                                                400
                                                              )}{" "}
                                                              {item.description
                                                                .length > 400 &&
                                                                "..."}{" "}
                                                              {item.description
                                                                .length < 395 &&
                                                                ledgerTransactions
                                                                  .find(
                                                                    (txn) =>
                                                                      txn.txn_id ===
                                                                      item.txn_id
                                                                  )
                                                                  ?.description?.includes(
                                                                    " (Reversed)"
                                                                  )
                                                                ? " (Reversed)"
                                                                : ""}
                                                            </td>
                                                          )}

                                                        {selectedValues?.columns?.includes(
                                                          "Debit"
                                                        ) && (
                                                            <td
                                                              className="htmltoPdfStyle"
                                                              id="test"
                                                              align="right"
                                                            >
                                                              {numberWithCommas(
                                                                parseFloat(
                                                                  item.debit_amount
                                                                ).toFixed(4)
                                                              )}
                                                            </td>
                                                          )}
                                                        {selectedValues?.columns?.includes(
                                                          "Credit"
                                                        ) && (
                                                            <td
                                                              className="htmltoPdfStyle"
                                                              id="test"
                                                              align="right"
                                                            >
                                                              {numberWithCommas(
                                                                parseFloat(
                                                                  item.credit_amount
                                                                ).toFixed(4)
                                                              )}
                                                            </td>
                                                          )}

                                                        {selectedValues?.columns?.includes(
                                                          "Balance"
                                                        ) && (
                                                            <td
                                                              className="htmltoPdfStyle"
                                                              id="test"
                                                              align="right"
                                                            >
                                                              {reportBalance
                                                                ? Math.sign(
                                                                  reportBalance
                                                                ) === 1
                                                                  ? `${numberWithCommas(
                                                                    reportBalance.toFixed(
                                                                      4
                                                                    )
                                                                  )} Dr.`
                                                                  : Math.sign(
                                                                    reportBalance
                                                                  ) === -1
                                                                    ? `${numberWithCommas(
                                                                      reportBalance
                                                                        .toFixed(
                                                                          4
                                                                        )
                                                                        .toString()
                                                                        .split(
                                                                          "-"
                                                                        )[1]
                                                                    )} Cr.`
                                                                    : "0"
                                                                : "0"}
                                                            </td>
                                                          )}

                                                        {/* <td>{item._id}</td> */}
                                                      </tr>
                                                    );
                                                  } else {
                                                    reportBalance +=
                                                      parseFloat(
                                                        item.debit_amount.toFixed(
                                                          4
                                                        )
                                                      ) -
                                                      parseFloat(
                                                        item.credit_amount.toFixed(
                                                          4
                                                        )
                                                      );

                                                    return (
                                                      <tr key={index}>
                                                        {selectedValues?.columns?.includes(
                                                          "Vr. No."
                                                        ) && (
                                                            <td
                                                              className="htmltoPdfStyle"
                                                              id="test"
                                                            >
                                                              {
                                                                item._id.split(
                                                                  "_"
                                                                )[1]
                                                              }
                                                            </td>
                                                          )}
                                                        {selectedValues?.columns?.includes(
                                                          "Reference No."
                                                        ) && (
                                                            <td
                                                              className="htmltoPdfStyle"
                                                              id="test"
                                                            >
                                                              {item.txn_id}
                                                            </td>
                                                          )}
                                                        {selectedValues?.columns?.includes(
                                                          "Instrument No."
                                                        ) && (
                                                            <td
                                                              className="htmltoPdfStyle"
                                                              id="test"
                                                            >
                                                              {ledgerTransactions.find(
                                                                (txn) =>
                                                                  txn.txn_id ==
                                                                  item.txn_id
                                                              )
                                                                ?.instrument_no ||
                                                                ""}
                                                            </td>
                                                          )}
                                                        {selectedValues?.columns?.includes(
                                                          "Settlement Date"
                                                        ) && (
                                                            <td
                                                              className="htmltoPdfStyle"
                                                              id="test"
                                                            >
                                                              {moment(
                                                                item.settlement_date
                                                              ).format(
                                                                "DD-MM-YYYY"
                                                              )}
                                                            </td>
                                                          )}

                                                        {selectedValues?.columns?.includes(
                                                          "Description"
                                                        ) && (
                                                            <td
                                                              className="htmltoPdfStyle"
                                                              id="test"
                                                            >
                                                              {item.description}{" "}
                                                              {ledgerTransactions
                                                                .find(
                                                                  (txn) =>
                                                                    txn.txn_id ==
                                                                    item.txn_id
                                                                )
                                                                ?.description?.includes(
                                                                  " (Reversed)"
                                                                )
                                                                ? " (Reversed)"
                                                                : ""}
                                                            </td>
                                                          )}

                                                        {selectedValues?.columns?.includes(
                                                          "Debit"
                                                        ) && (
                                                            <td
                                                              className="htmltoPdfStyle"
                                                              id="test"
                                                              align="right"
                                                            >
                                                              {numberWithCommas(
                                                                parseFloat(
                                                                  item.debit_amount
                                                                ).toFixed(4)
                                                              )}
                                                            </td>
                                                          )}
                                                        {selectedValues?.columns?.includes(
                                                          "Credit"
                                                        ) && (
                                                            <td
                                                              className="htmltoPdfStyle"
                                                              id="test"
                                                              align="right"
                                                            >
                                                              {numberWithCommas(
                                                                parseFloat(
                                                                  item.credit_amount
                                                                ).toFixed(4)
                                                              )}
                                                            </td>
                                                          )}

                                                        {selectedValues?.columns?.includes(
                                                          "Balance"
                                                        ) && (
                                                            <td
                                                              className="htmltoPdfStyle"
                                                              id="test"
                                                              align="right"
                                                            >
                                                              {reportBalance
                                                                ? Math.sign(
                                                                  reportBalance
                                                                ) === 1
                                                                  ? `${numberWithCommas(
                                                                    reportBalance.toFixed(
                                                                      4
                                                                    )
                                                                  )} Dr.`
                                                                  : Math.sign(
                                                                    reportBalance
                                                                  ) === -1
                                                                    ? `${numberWithCommas(
                                                                      reportBalance
                                                                        .toFixed(
                                                                          4
                                                                        )
                                                                        .toString()
                                                                        .split(
                                                                          "-"
                                                                        )[1]
                                                                    )} Cr.`
                                                                    : "0"
                                                                : "0"}
                                                            </td>
                                                          )}

                                                        {/* <td>{item._id}</td> */}
                                                      </tr>
                                                    );
                                                  }
                                                }
                                              )
                                            : null}
                                        </tbody>
                                      </table>
                                      {selectedValues?.balance?.includes(
                                        "Closing Balance"
                                      ) && (
                                          <div id="test" className="float-right">
                                            <b id="test">Closing Balance</b>:{" "}
                                            <span> </span>
                                            {reportBalance
                                              ? Math.sign(reportBalance) === 1
                                                ? `${numberWithCommas(
                                                  reportBalance.toFixed(4)
                                                )} Dr.`
                                                : Math.sign(reportBalance) === -1
                                                  ? `${numberWithCommas(
                                                    reportBalance
                                                      .toFixed(4)
                                                      .toString()
                                                      .split("-")[1]
                                                  )} Cr.`
                                                  : "0"
                                              : "0"}
                                          </div>
                                        )}
                                    </div>
                                  </div>
                                ) : (
                                  <div className="text-center my-5">
                                    <b>No column selected</b>
                                  </div>
                                )}
                              </>
                            ) : (
                              <div className="table-empty">
                                <BsTable className="icon" />
                                <p className="text-center text-primary empty-text">
                                  No record found
                                </p>
                              </div>
                            )}
                          </div>
                        </PDFExport>
                      </div>
                    </div>
                    <div className="row align-items-center">
                      <div className="col-md-4">
                        {selectedValues?.columns?.length > 0 &&
                          ledgerResponse.length >= 10 && (
                            <UncontrolledDropdown
                              className="me-2 mt-2"
                              direction="down"
                            >
                              <DropdownToggle
                                id="TotalRecord_dropdown"
                                style={{
                                  background: "none",
                                  padding: "0px",
                                  margin: "0px",
                                }}
                                className="border"
                              // style={{
                              //   borderRadius: "4px",
                              //   color: theme === "light" ? "black" : "",
                              // }}
                              // caret
                              // size="sm"
                              >
                                <div
                                  id="report_dropdown"
                                  style={{
                                    borderRadius: "4px",
                                    padding: "5px 15px",
                                    color: theme == "light" ? "black" : "white",
                                  }}
                                >
                                  Per page : {itemsPerPage}
                                </div>

                                {/* {selectedValues?.columns?.length > 0 &&
                                bankStatementDataCount > 0
                                ? bankStatement?.length
                                : 0} */}
                              </DropdownToggle>
                              <DropdownMenu
                                style={{
                                  // width: "100%",
                                  maxHeight: "300px",
                                  overflow: "auto",
                                  backgroundColor:
                                    theme == "dark" ? "rgb(30, 30, 47)" : "",
                                }}
                              >
                                <DropdownItem
                                  className={
                                    itemsPerPage == 10
                                      ? "bg-info text-white"
                                      : ""
                                  }
                                  onClick={() => {
                                    setItemsPerPage(10);
                                    setItemsToShow(10);
                                  }}
                                >
                                  10
                                </DropdownItem>
                                <DropdownItem
                                  className={
                                    itemsPerPage == 25
                                      ? "bg-info text-white"
                                      : ""
                                  }
                                  onClick={() => {
                                    setItemsPerPage(25);
                                    setItemsToShow(25);
                                  }}
                                >
                                  25
                                </DropdownItem>
                                <DropdownItem
                                  className={
                                    itemsPerPage == 50
                                      ? "bg-info text-white"
                                      : ""
                                  }
                                  onClick={() => {
                                    setItemsPerPage(50);
                                    setItemsToShow(50);
                                  }}
                                >
                                  50
                                </DropdownItem>
                                <DropdownItem
                                  className={
                                    itemsPerPage == "All"
                                      ? "bg-info text-white"
                                      : ""
                                  }
                                  onClick={() => {
                                    setItemsPerPage("All");
                                    setItemsToShow(ledgerResponse?.length);
                                  }}
                                >
                                  All
                                </DropdownItem>
                              </DropdownMenu>
                            </UncontrolledDropdown>
                          )}
                      </div>
                      <div className="col-md-4">
                        {itemsToShow < ledgerResponse?.length &&
                          selectedValues?.columns?.length > 0 && (
                            <div className="d-flex justify-content-center my-2">
                              <button
                                className="btn btn-primary mt-3"
                                onClick={handleShowMore}
                              >
                                Show More
                              </button>
                            </div>
                          )}
                      </div>
                      <div className="col-md-4">
                        {selectedValues?.columns?.length > 0 &&
                          ledgerResponse.length > 0 && (
                            <div className="d-flex justify-content-end">
                              <div
                                id="TotalRecord_dropdown"
                                className="border dropdown-toggle btn btn-secondary btn-sm ml-1"
                                style={{
                                  borderRadius: "4px",
                                  color: theme == "light" ? "black" : "white",
                                  marginTop: "13px",
                                }}
                              >
                                Total record :{" "}
                                {selectedValues?.columns?.length > 0
                                  ? ledgerResponse?.length
                                  : 0}
                              </div>
                            </div>
                          )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Container>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default GeneralLegderReport;
